export const routes = {
  ALL: {
    path: '*',
    element: 'pages/not-found/NotFoundPage',
  },
  ROOT: {
    path: '/*',
    element: null,
  },
  LOGIN: {
    path: 'login',
    element: 'pages/login/LoginPage',
  },
  HEALTH: {
    path: 'health',
    element: 'pages/health/HealthPage',
  },
  PROJECTS: {
    path: 'projects',
    element: 'pages/projects/ProjectsPage',
  },
  PROJECT: {
    path: 'projects/:project_id',
    element: '',
  },
  BATCHES: {
    path: 'projects/:project_id/batches/all',
    element: 'pages/batches/BatchesPage',
  },
  BATCH: {
    path: 'projects/:project_id/batches/all/:batch_id',
    element: null,
  },
  BATCH_DEFINITIONS: {
    path: 'projects/:project_id/batch_definitions/all',
    element: 'pages/batch-definitions/BatchDefinitionsPage',
  },
  BATCH_DEFINITION: {
    path: 'projects/:project_id/batch_definitions/all/:batch_definition_id',
    element: 'components/navigation/BatchDefinition',
  },
  SCHEDULED_BATCHES: {
    path: 'projects/:project_id/scheduled_batches/all',
    element: 'pages/scheduled-batches/ScheduledBatchesPage',
  },
  SCHEDULED_BATCH: {
    path: 'projects/:project_id/scheduled_batches/all/:scheduled_batch_id',
    element: 'pages/scheduled-batch/ScheduledBatchPage',
  },
  JOBS: {
    path: 'projects/:project_id/jobs/:job_state',
    element: 'pages/jobs/JobsPage',
  },
  JOB: {
    path: 'projects/:project_id/jobs/:filter/:job_id',
    element: 'pages/job/JobPage',
  },
  JOB_DEFINITIONS: {
    path: 'projects/:project_id/job_definitions/all',
    element: 'pages/job-definitions/JobDefinitionsPage',
  },
  JOB_DEFINITION: {
    path: 'projects/:project_id/job_definitions/all/:job_definition_id',
    element: 'pages/job-definition/JobDefinitionPage',
  },
};
